import React, { useState } from 'react'
import useStyles from './useStyle'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import { SearchUser } from './SearchUser/SearchUser'

export const AdminSessions = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Administración de sesiones
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá administrar las sesiones abiertas de un usuario de
          Errepar+.
        </Typography>
      </div>
      <SearchUser setLoading={setLoading} />
    </div>
  )
}
